/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LicenseCardModule */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { ILicensePool, IOrgServiceUnits } from 'generated-types';
import * as globalL10n from 'global-l10n';
import './license-card.component.less';
import * as l10n from './license-card.l10n';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Card to display license usage data for controller and organization.
 * @author Nikhil Sharma, alextsg, Shubam Bindal
 */

@Component({
    selector: 'license-card',
    templateUrl: './license-card.component.html',
})
export class LicenseCardComponent {
    /**
     * Flag to display spinner when application is fetching license data.
     */
    @Input()
    public isBusy: boolean;

    /**
     * Reserved License service cores.
     */
    @Input()
    public reservedServiceCores = 0;

    /**
     * Available License service cores.
     */
    @Input()
    public availableServiceCores = 0;

    /**
     * Used service cores from total licensed service cores.
     */
    @Input()
    public usedServiceCores = 0;

    /**
     * Organization-related licensing information.
     */
    @Input()
    public orgServiceUnits: IOrgServiceUnits;

    /**
     * License pool information from saasStatus for Pool usage.
     */
    @Input()
    public licensePool: ILicensePool;

    /**
     * Name of license tier used.
     */
    @Input()
    public licenseTierTitle: string;

    /**
     * Default license tier used.
     */
    @Input()
    public licenseTier: string;

    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
